<template>
    <div class="desktopdeliverylist">
        <table class="table">
            <template v-for="(group, groupindex) in ordergroup">
                <template v-if="checkhasaccepted(group)">
                    <thead :key="groupindex+'thead'">
                        <tr>
                            <td colspan="5">

                                <template v-if="group.date == 'pastdue'">
                                    <h3>Past Due</h3>
                                </template>

                                <template v-else>
                                    <h3>{{group.date | formatreldate}}</h3>
                                </template>
                            </td>
                        </tr>

                        <tr v-if="groupindex == 0">
                            <th>QTY</th>
                            <th>NAME</th>
                            <th>PHONE</th>
                            <th>DELIVERY TIME </th>
                            <th>ADDRESS</th>
                            <td></td>
                        </tr>
                    </thead>

                    <tbody :key="groupindex+'tbody'">
                        <template v-for="(order, orderindex) in group.orders">
                            <tr 
                                v-if="checkstatus(order, 'accepted')"
                                :key="orderindex+'mainrow'">
                                <td @click="viewOrder(order)" >
                                    <div class="itemSize">
                                        <span class="itemNumber">
                                            {{order.order.numberofboxes}}
                                        </span>
                                        <span class="doz">
                                            DOZ
                                        </span>
                                    </div>
                                </td>

                                <td @click="viewOrder(order)" >{{order.order.contact_name}}</td>
                                <td @click="viewOrder(order)" >{{order.order.phone_number | VMask('(###) ###-####')}}</td>
                                <td @click="viewOrder(order)" >{{order.order.order_event_time_range ? `${order.order.order_event_time_range}, ` : ''}} {{order.order.delivery_date | formatdate('MMM D')}}</td>

                                <td>
                                    <b-row no-gutters>
                                        <b-col cols="3">
                                            <div 
                                                @click="openMap('drive', order.order)"
                                                class="googleMap">
                                                <GmapMap
                                                    :options="mapOptions"
                                                    :center="{
                                                        lat: parseFloat(order.order.shipping_address_latitude),
                                                        lng: parseFloat(order.order.shipping_address_longitude)
                                                    }"
                                                    :zoom="10"
                                                    map-type-id="roadmap"
                                                >
                                                    <GmapMarker
                                                        :icon="svgMarker"
                                                        :position="{
                                                            lat: parseFloat(order.order.shipping_address_latitude),
                                                            lng: parseFloat(order.order.shipping_address_longitude)
                                                        }"
                                                    />
                                                </GmapMap>
                                            </div>
                                        </b-col>

                                        <b-col @click="viewOrder(order)" cols="9" class="pl-4">
                                            {{order.order.shipping_address_street}} {{order.order.shipping_address_city}} {{order.order.shipping_address_state}} {{order.order.shipping_address_zipcode}}   
                                        </b-col>
                                    </b-row>
                                    
                                </td>

                                <td @click="viewOrder(order)">

                                    <b-iconstack font-scale="2">
                                        <b-icon
                                            stacked
                                            icon="chevron-right"
                                            scale="0.5"
                                        ></b-icon>
                                        <b-icon stacked icon="circle"></b-icon>
                                    </b-iconstack>
                                </td>
                            </tr>

                            <tr 
                                v-if="checkstatus(order, 'accepted')"
                                :key="orderindex+'space'" class="space">
                                <td colspan="6"></td>
                            </tr>

                        </template>
                        
                        
                    </tbody>
                </template>
            </template>
        </table>

       
    </div>
</template>

<script>
/**
 * Declerations
 */

// mixins
// import {mapMixins} from '@/mixins/mapMixins';
// import {ordermixins} from '@/mixins/ordermixins'
import {deliverylistmixins} from '@/mixins/driverdeliverylistmixins'

//Helper
// import Helper from '@/helpers/helper'

export default {
    mixins : [deliverylistmixins],
    // props : {
    //     ordergroup : {
    //         type   : Array,
    //         default: () => []
    //     }
    // },
    // filters : {
    //     /**
    //      * Format date by 
    //      * @param format
    //      */
    //     formatdate(date, format) {
    //         return date ? Helper.formatdate(date, format) : ''
    //     },
    //     /**
    //      * Format date by relation like
    //      * Today, Tomorrow, and MM/DD/YYYY
    //      */
    //     formatreldate(date) {
    //         return Helper.datestring(date)
    //     }
    // },
    // methods : {
    //     /**
    //      * Check if group has accpeted order
    //      * @param group 
    //      */
    //     checkhasaccepted(group) {
    //         const accepted = group.orders.filter(o => o.order.status == 'accepted' || o.order.status == 'amend')

    //         return accepted.length > 0 ? true : false
    //     },
    //      /**
    //      * View order details
    //      * @param id assigned record id
    //      */
    //     viewOrder(order){
    //         this.$router.push({
    //             name : 'order',
    //             params : {id : order.id}
    //         })
    //     },
    //     /**
    //      * Check if order status is accepted
    //      * @param order
    //      * @param status
    //      */
    //     checkstatus(order, status) {
    //         if(status == 'accepted') {
    //             return order.order.status == 'accepted' || order.order.status == 'amend' ? true : false
    //         } else {
    //             return order.order.status == status ? true : false
    //         }
    //     },
    // }
}
</script>

<style lang="scss">
@import "@/scss/partials/_colors.scss";
@import "@/scss/partials/_mixins.scss";

.desktopdeliverylist {

    .vue-map-container {
        min-height: 60px;
        height: 100%;
    }

    .table {
           td,
           th {
               border: none;
               vertical-align: middle;
           }
   
           thead {
               th {
                   font-weight: 800;
                   text-transform: uppercase;
                   font-size: 13px;
   
                   &:first-child {
                       padding-left: 60px;
                   }
               }
           }
   
           tbody {
           
   
               tr {
                    background-color: #fff;

                    &.space {
                        background-color: transparent;
                        td {
                            padding : 5px;
                        }
                    }
                
                   td {
                       &:first-child {
                           padding-left: 60px;
                       }
   
                       .bi-circle {
                           color : $lightgrey2;
                       }
                   }
   
                   &.rowexpanded {
                       background-color: #fff;
                       border-bottom: 1px solid $lightgrey2;
                   }
   
                   &.ordermoredetails {
                       background-color: #fff;
                       td {
                           padding-top: 30px;
                           padding-left: 0;
   
                           .moredetailsinner {
                               padding-left : 120px;
                           }
                       }
                   }
               }
           }
       }
}
</style>